import React from 'react';
import { Button } from './Button';
export function FinalCTA() {
  return <footer className="bg-[#1A1A1A] text-white pt-24 pb-12 relative overflow-hidden" data-id="element-109">
      {/* Italian Flag Top Accent */}
      <div className="absolute top-0 left-0 w-full h-2 flex" data-id="element-110">
        <div className="flex-1 bg-brand-green" data-id="element-111"></div>
        <div className="flex-1 bg-white" data-id="element-112"></div>
        <div className="flex-1 bg-brand-red" data-id="element-113"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-114">
        <div className="mb-12" data-id="element-115">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4 flex items-center justify-center" data-id="element-116">
            <span className="mr-3" data-id="element-117">🇮🇹</span> ITALIANO 360
          </h2>
          <p className="text-xl text-gray-400" data-id="element-118">
            El sistema de planificación N°1 para profesores de italiano
            argentinos.
          </p>
        </div>

        <div className="mb-16" data-id="element-119">
          <p className="text-3xl md:text-4xl font-serif italic text-[#FAF7F2] leading-relaxed" data-id="element-120">
            "Porque preparar una buena clase
            <br className="hidden md:block" data-id="element-121" /> no debería costarte todas las
            noches
            <br className="hidden md:block" data-id="element-122" /> de la semana."
          </p>
        </div>

        <div className="mb-16" data-id="element-123">
          <Button href="#pricing" variant="primary" size="lg" className="shadow-2xl shadow-brand-green/20 mb-8" data-id="element-124">
            SÍ, QUIERO MI ITALIANO 360 AHORA →
          </Button>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400" data-id="element-125">
            <span data-id="element-126">🛡️ Garantía 7 días</span>
            <span className="hidden md:inline" data-id="element-127">|</span>
            <span data-id="element-128">🔒 Pago seguro</span>
            <span className="hidden md:inline" data-id="element-129">|</span>
            <span data-id="element-130">⚡ Acceso inmediato</span>
            <span className="hidden md:inline" data-id="element-131">|</span>
            <span data-id="element-132">🇦🇷 Hecho en Argentina para Argentina</span>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-12 mt-12" data-id="element-133">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6 mb-8 text-gray-400" data-id="element-134">
            <div className="font-bold text-white flex items-center" data-id="element-135">
              🇮🇹 ITALIANO 360™
            </div>
            <div className="flex flex-wrap justify-center gap-6" data-id="element-136">
              <a href="mailto:contacto@italiano360.com.ar" className="hover:text-white transition-colors" data-id="element-137">
                📧 contacto@italiano360.com.ar
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-138">
                📲 @italiano360.ar
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-139">
                🌐 www.italiano360.ar
              </a>
            </div>
          </div>

          <p className="text-sm text-gray-600" data-id="element-140">
            © ITALIANO 360™ 2025 — Todos los derechos reservados. Prohibida la
            reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}